export default class Stripe {
  constructor() {
    this.API_URL = process.env.REACT_APP_API_URL;
    this.PRICE_ID = process.env.REACT_APP_STRIPE_PRICE_ID;
  }

  createCheckoutSession = async (token) => {
    return fetch(this.API_URL + '/create_checkout_session/', {
      method: 'POST',
      mode: 'cors',
      cache: 'no-cache',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      redirect: 'follow',
      referrerPolicy: 'no-referrer',
      body: JSON.stringify({priceId: this.PRICE_ID})
    }).then(response => {
      if (!response.ok) {
      return response.json().then(function(json) {
        if (json.error && json.error.message) {
          console.log(response.url + ' ' + response.status + ' ' + json.error.message);
        }
      }).catch(function(err) {
        console.log(err);
      });
    }
    return response.json();
   });
  }

  openBillingPortal = async (token) => {
    return fetch(this.API_URL + '/get_customer_portal/', {
      method: 'POST',
      mode: 'cors',
      cache: 'no-cache',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      redirect: 'follow',
      referrerPolicy: 'no-referrer'
    }).then(response => {
      if (!response.ok) {
      return response.json().then(function(json) {
        if (json.error && json.error.message) {
          console.log(response.url + ' ' + response.status + ' ' + json.error.message);
        }
      }).catch(function(err) {
        console.log(err);
      });
    }
    return response.json();
   });
  }

   hasActiveStripe = async (token) => {
    return fetch(this.API_URL + '/has_active_stripe/', {
      method: 'GET',
      mode: 'cors',
      cache: 'no-cache',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      redirect: 'follow',
      referrerPolicy: 'no-referrer'
    }).then(response => {
      if (!response.ok) {
      return response.json().then(function(json) {
        if (json.error && json.error.message) {
          console.log(response.url + ' ' + response.status + ' ' + json.error.message);
        }
      }).catch(function(err) {
        console.log(err);
      });
    }
    return response.json();
   });
  }
}
